import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderSetupRoutingModule } from './order-setup-routing.module';
import { OrderSetupComponent } from './order-setup.component';
import { AccountComponent } from './account/account.component';
import { OrderTemplateComponent } from './order-template/order-template.component';
import { QuotationComponent } from './quotation/quotation.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContractComponent } from './contract/contract.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
  declarations: [
    OrderSetupComponent,
    AccountComponent,
    OrderTemplateComponent,
    QuotationComponent,
    ContractComponent
  ],
  imports: [
    CommonModule,
    OrderSetupRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    OverlayPanelModule
  ],
  exports: [
    OrderSetupComponent
  ]
})
export class OrderSetupModule { }
